<template>
	<div class="faq-iframe-top-bar">
		<a 
			:href="settings.logo_link" 
			target="_blank">
			<img :src="settings.logo_url" alt="NEK" />
		</a>
		<nav>
			<button 
				:class="['dc-button--type-secondary', 'question', {
					active : slug==='new-question'
				}]"
				@click.stop.prevent="showQuestionForm()">{{ settings.new_question_label }}</button>
			<button 
				:class="['dc-button--type-secondary', 'info', {
					active : slug==='info'
				}]" 
				@click.stop.prevent="changePage('info')"><span class="label">{{ settings.info_label }}</span></button>
			<button class="dc-button--type-secondary close" 
				@click.stop.prevent="closeFaq"><span class="screen-reader-text">{{ settings.close_window_label }}</span><i class="icon icon-close"></i></button>
		</nav>
	</div>
</template>

<script>
export default {
	props: {
		settings: {
			type: Object,
			required: true,
		},
		activePage: {
			type: String,
			required: true,
			default: '',
		}
	},
	methods: {
		changePage(slug) {
			const nextSlug = (slug!==this.activePage) ? slug : '';
			this.$emit('showPage', nextSlug);
		},
		closeFaq() {
			window.parent.postMessage({name: 'closeNEKFAQ'}, '*');
		},
		showQuestionForm() {
			this.$emit('showQuestionForm');
		}
	}

};
</script>
